import React from "react";
import Container from "@mui/material/Container";
import { Box, Grid, Link, Typography } from "@mui/material";
import img15 from "../../utils/img/Galeria/27.jpg";
import Image1 from "../../utils/img/otros/camionprueba.jpg";
const Nosotros = () => {
  return (
    <Box style={{ paddingBottom: "50px" }}>
      <Container>
        <Grid
          container
          spacing={4}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12} md={6}>
            <Box>
              <Box className="textNosotros">
                <Typography
                  gutterBottom
                  variant="h5"
                  component="div"
                  className="negrita"
                >
                  Sobre Nosotros
                </Typography>
                <Typography variant="body2" style={{ marginBottom: "15px" }}>
                  TRANSMDICAS S.R.L. es una de las principales empresas que
                  conforman el GRUPO PEZO, la cual cuenta con amplia trayectoria
                  en el transporte de materiales peligrosos y carga en general,
                  iniciando sus actividades en el año 2002, desde entonces el
                  crecimiento ha sido exponencial posicionándose en el mercado
                  con una flota de unidades realizando el transporte para
                  diferentes unidades mineras e industrias.
                </Typography>
                <Typography variant="body2">
                  Buscamos lograr la excelencia en el servicio de transporte
                  orientando esfuerzos a lograr satisfacer los requisitos de
                  nuestros clientes cumpliendo nuestros estándares de calidad,
                  medio ambiente, seguridad y salud en el trabajo y seguridad
                  vial.
                </Typography>
                <Typography variant="body2">
                  Contamos con un equipo multidisciplinario de profesionales con
                  amplia experiencia en el servicio ofreciendo soluciones
                  confiables, oportunas y eficientes.
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={5}>
            <div className="imagenNosotrosHome">
              <img src={img15} className="imgNosotrosHome" />
            </div>
          </Grid>
        </Grid>
        <Box mt={8}>
          <Typography variant="h5" gutterBottom fontWeight={600}>
            Certificaciones y Alcance del SIG
          </Typography>

          <Typography variant="body2" mb={2}>
            Transmdicas S.R.L, Empresa de transporte de carga general por
            carretera determina el alcance del Sistema Integrado de gestión,
            Basándose en su contexto que hace referencia en el{" "}
            <strong>apartado 4.1</strong>, y a las necesidades y expectativas de
            las partes interesadas referidas en el <strong>apartado 4.2</strong>
            . A los requisitos legales y otros requisitos de las partes
            interesadas, las unidades, funciones y límites físicos de la
            empresa, su autoridad e influencia de sus actividades y servicios
            (Transporte).
          </Typography>
          <Typography variant="body2" mb={2}>
            El alcance de la certificación del SIG, comprende:
          </Typography>

          <Box pl={2} mb={2}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              Para ISO 9001:2015
            </Typography>
            <Typography variant="body2" gutterBottom>
              Servicio de transporte de materiales peligrosos y carga en general
            </Typography>

            <Typography variant="body2" mt={1}>
              <strong>Exclusiones:</strong>
            </Typography>
            <ul style={{ marginTop: 0, marginBottom: "1rem" }}>
              <li>
                <Typography variant="body2">
                  Requisito 8.3 Diseño y Desarrollo de los productos y servicios
                </Typography>
              </li>
            </ul>

            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              Para ISO 14001:2015
            </Typography>
            <Typography variant="body2" gutterBottom>
              Servicio de transporte de materiales peligrosos y carga en general
            </Typography>

            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              Para ISO 45001:2018
            </Typography>
            <Typography variant="body2" gutterBottom>
              Servicio de transporte de materiales peligrosos y carga en general
            </Typography>

            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              Para ISO 39001:2012
            </Typography>
            <Typography variant="body2" gutterBottom>
              Servicio de transporte por carretera de materiales peligrosos y
              carga en general
            </Typography>

            <Typography variant="body2" mt={2}>
              <strong>SEDE 1:</strong> Asociación Casa Granja-Villa Arapa Mz N
              Lote 1, 2, 13 y 14 - Cerro Colorado Arequipa.
            </Typography>
            <Typography variant="body2">
              <strong>SEDE 2:</strong> Vía Evitamiento Km 6.5 Cerro Colorado
              Arequipa
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Nosotros;
